module.exports = __webpack_public_path__ + "static/img-features--jahreszeit-9dc39a5bbf7ce588bd68ecbb01ef0882.png";